// Lista base de estudiantes de GeoCeuta con sus avatares optimizados en WebP
const STUDENT_NAMES = [
    'Amir',
    'Haron',
    'Hiba',
    'Imran',
    'Lina',
    'Mohamed',
    'Moshab',
    'Nermin',
    'Norhan',
    'Raed',
    'Rawia',
    'Rayan',
    'Siraj',
    'Yannat',
    'Yawhara'
];

export const getStudents = () => {
    const students = STUDENT_NAMES.map(name => ({
        id: name,
        name: name,
        avatar: `/avatars/${name}.webp`
    }));

    return students.sort((a, b) => a.name.localeCompare(b.name));
};

